import { render } from "./IconPayWithin48_Modern.vue.js?vue&type=template&id=3a17e137!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconPayWithin48_Modern.vue?vue&type=template&id=3a17e137"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__